import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {SaleRetrocessionModel} from "../../../api/entity/saleRetrocession.model";
import {AbstractRepositoryV2} from "../../../../../../core/service/v2/abstractRepositoryV2";

@Injectable()
export class SaleRetrocessionRepository extends AbstractRepositoryV2<SaleRetrocessionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('SaleRetrocession', serviceElementsFactory, injector);
    }
}